import {FormikContextType} from 'formik'
import {TicketSubmitFormValues} from '../TicketSubmitWaiverFormDrawer/TicketSubmitWaiverForm'

interface TermsAndConditionsCheckBoxProps {
  formik: FormikContextType<TicketSubmitFormValues>
  disabled?: boolean
}

export const TermsAndConditionsCheckBox = ({
  formik,
  disabled = false,
}: TermsAndConditionsCheckBoxProps) => {
  return (
    <>
      <div>
        <input
          style={{
            cursor: 'pointer',
          }}
          disabled={disabled}
          className='form-check-input me-2 bg-primary-dw-darker border border-1 border-primary'
          type='checkbox'
          checked={formik.values.termsAndConditions}
          {...formik.getFieldProps('termsAndConditions')}
        />
      </div>
      <div className='flex-grow-1'>
        <p className='mb-0 text-white fs-6 fw-bolder'>
          I have read and Agree to the{' '}
          <a
            rel='noreferrer'
            target='_blank'
            href='https://www.yasmarinacircuit.com/legal#privacycookies'
            className='text-primary'
          >
            terms & conditions{' '}
          </a>
          and
          <a
            rel='noreferrer'
            target='_blank'
            href='https://www.yasmarinacircuit.com/legal#privacycookies'
            className='text-primary'
          >
            {' '}
            Privacy Policy
          </a>
        </p>

        <p className='mb-0 text-white fs-6 fw-bolder'>
          لقد قرأت وأوافق على{' '}
          <a
            rel='noreferrer'
            target='_blank'
            href='https://www.yasmarinacircuit.com/legal#privacycookies'
            className='text-primary'
          >
            الشروط والأحكام{' '}
          </a>
          و{' '}
          <a
            rel='noreferrer'
            target='_blank'
            href='https://www.yasmarinacircuit.com/legal#privacycookies'
            className='text-primary'
          >
            سياسة الخصوصية
          </a>
        </p>

        {formik.errors.termsAndConditions && formik.touched.termsAndConditions && (
          <div className='fv-plugins-message-container mb-3'>
            <div className='fv-help-block'>
              <span className='' role='alert'>
                {formik.errors.termsAndConditions}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
